<form [formGroup]="inputGroup">
  <div class="radio-button_container" *ngFor="let item of values" (click)="radioButton.click()">
    <div class="radio-button">
      <input 
        type="radio"
        #radioButton
        [formControlName]="fieldName"
        [value]="item"
        [name]="fieldName"
      >
    </div>
    <span class="p2">{{item}}</span>
  </div>
</form>
